import { msg } from '@lingui/core/macro';
import { defineFilters } from '@/shared/filters/define-filters';

/** Único filtro do legado (`UsersAndGroup.tsx:61-85`): "Nome" → `searchString`. */
export const userGroupFilters = defineFilters([
  { key: 'searchString', type: 'search', label: msg`Nome`, placeholder: msg`Filtrar por nome` },
]);
